/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RcsAgent } from './rcsAgent';

export interface RcsAgentPager { 
    totalItems?: number;
    currentPage?: number;
    pageSize?: number;
    readonly totalPages?: number;
    readonly startPage?: number;
    readonly endPage?: number;
    readonly startIndex?: number;
    readonly endIndex?: number;
    readonly pages?: Array<number>;
    readonly result?: Array<RcsAgent>;
}